import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const USERS_LOAD = 'USERS_LOAD'
export const USER_LOAD = 'USER_LOAD'
export const USER_CREATE = 'USER_CREATE'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_DESTROY = 'USER_DESTROY'
export const USER_STATE_UPDATE = 'USER_STATE_UPDATE'

const usersApi = new Api(UrlStore.USERS)
const userSchema = new schema.Entity('users')

export default {
  namespaced: true,
  state: {
    usersLoaded: false,
    usersList: [],
    usersPager: {},
    entities: {
      users: {}
    }
  },
  getters: {
    users(state) {
      return state.usersList.map((bId) => state.entities.users[bId])
    },
    getUser: (state) => (userId) => state.entities.users[userId] || null
  },
  mutations: {
    [USERS_LOAD](state, payload) {
      let normData = normalize(payload.items, [userSchema])
      state.usersList = normData.result
      state.usersPager = payload.pager
      setEntities(state, normData)
    },
    [USER_LOAD](state, payload) {
      let normData = normalize(payload, userSchema)
      setEntities(state, normData)
    },
    [USER_CREATE](state, user) {
      state.usersList.push(user.id)
      Vue.set(state.entities.users, user.id, user)
    },
    [USER_UPDATE](state, user) {
      if (user.id && state.entities.users[user.id]) {
        state.entities.users[user.id] = Object.assign({}, state.entities.users[user.id], user)
      }
    },
    [USER_DESTROY](state, user) {
      let num = state.usersList.findIndex((cId) => cId === user.id)
      if (num !== -1) {
        state.usersList.splice(num, 1)
        delete state.entities.users[user.id]
      }
    },
    [USER_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    usersLoad({ commit }, config = {}) {
      usersApi.getAll(config).then((r) => {
        commit(USERS_LOAD, r.data)
        commit(USER_STATE_UPDATE, { usersLoaded: true })
      })
    },
    userLoad({ commit }, config) {
      usersApi.get({ id: config.id, config: config }).then((r) => {
        commit(USER_LOAD, r.data)
      })
    },
    userSave({ commit, getters }, user) {
      if (!user.id) throw new Error('User id is not present in `userSave`!')
      commit(getters.getUser(user.id) ? USER_UPDATE : USER_CREATE, user)
      let userUpdated = getters.getUser(user.id)

      return usersApi.save(userUpdated).then((r) => {
        if (r._isNew) {
          commit(USER_DESTROY, userUpdated) // local
          commit(USER_CREATE, r.data)
        } else {
          commit(USER_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    userDestroy({ commit }, user) {
      usersApi.destroy({ id: user.id }).then(() => {
        commit(USER_DESTROY, user)
      })
    }
  }
}
